'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _interopRequireWildcard = require('babel-runtime/helpers/interop-require-wildcard')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reducer = require('./reducer');

var actions = _interopRequireWildcard(_reducer);

var _Window2 = require('./Window');

var _Window3 = _interopRequireDefault(_Window2);

var ModalWindow = (function (_Window) {
	_inherits(ModalWindow, _Window);

	function ModalWindow(title, text, buttons, style) {
		_classCallCheck(this, ModalWindow);

		_Window.call(this, title, text, style);
		this.buttons = buttons;
	}

	ModalWindow.prototype.hide = function hide() {
		this.dispatch(actions.closeModal(this.modal));
	};

	ModalWindow.prototype.dispatch = function dispatch(_dispatch, modal) {
		this.dispatch = _dispatch;
		this.modal = modal;
		_dispatch(actions.openModal(this.modal));
	};

	ModalWindow.prototype.show = function show(dispatch) {
		var _this = this;

		var modal = _react2['default'].createElement(
			_reactBootstrap.Modal,
			{ animation: false, show: true, onHide: function () {
					return _this.hide();
				}, bsStyle: this.style },
			_react2['default'].createElement(
				_reactBootstrap.Modal.Header,
				{ closeButton: true },
				_react2['default'].createElement(
					_reactBootstrap.Modal.Title,
					null,
					this.title
				)
			),
			_react2['default'].createElement(
				_reactBootstrap.Modal.Body,
				null,
				_react2['default'].createElement(
					'div',
					{ style: { padding: '20px 5px' } },
					this.text
				)
			),
			_react2['default'].createElement(
				_reactBootstrap.Modal.Footer,
				null,
				this.buttons
			)
		);
		this.dispatch(dispatch, modal);
	};

	return ModalWindow;
})(_Window3['default']);

exports['default'] = ModalWindow;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-modal/src/ModalWindow.js
 ** module id = 246
 ** module chunks = 1
 **/